export default [
  {
    path: '/swap',
    name: 'Swap',
    component: () => import('@/views/swap/index.vue'),
    meta: {
      auth: true, // 需要登录
      title: '兑换',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]

